import Axios, { InternalAxiosRequestConfig } from 'axios';
import toast from 'react-hot-toast';
import { getBaseUrl } from 'lib/utils';

const noCredentials = ['/sign-up', '/sign-up-v2', '/sign-up-otp'];

export function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  if (config.url) {
    const url = config.url.split('?')[0];

    if (!noCredentials.includes(url)) config.withCredentials = true;

    return {
      ...config,
      headers: {
        ...config.headers,
      },
    } as InternalAxiosRequestConfig;
  }

  return config;
}

export const apiClient = Axios.create({
  baseURL: getBaseUrl() + process.env.REACT_APP_API_VERSION,
});

apiClient.interceptors.request.use(authRequestInterceptor);

apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    try {
      const url = error.response?.config?.url;
      const message =
        error.response?.data?.error_title ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;

      if (
        !['Whatsapp not verified', 'Ongoing Session', 'Token Expired'].includes(
          message
        ) &&
        ![
          '/lab_report_details',
          '/ai_report_details',
          '/family-member-attributes?os=web&locale=en-us',
          '/login-v2',
        ].includes(url)
      )
        toast.error(message);
    } catch (error) {
      console.error(error);
    }

    return Promise.reject(error);
  }
);
